// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".history-online-meeting-list-tab[data-v-676bd542]{width:100%;margin-left:auto;margin-right:auto}.history-online-meeting-list-tab .history-period .title[data-v-676bd542]{font-weight:700}.history-online-meeting-list-tab .history-period .history-option[data-v-676bd542]{width:120px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
